import React from 'react'
import {Link} from 'react-router-dom'
import {useTestContext} from './TestContext'

const TestTabs: React.FC = () => {
  const {activeTab, handleTabClick, currentUser} = useTestContext()

  return (
    <div className='mt-4'>
      <div className='d-flex h-55px'>
        <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-semibold flex-nowrap '>
          <li className='nav-item'>
            <Link
              to={`/tests`}
              className={`nav-link me-6 ${
                activeTab === 'overview' ? 'text-active-primary active' : ''
              }`}
              onClick={() => handleTabClick('overview')}
            >
              Overview
            </Link>
          </li>

          {currentUser?.account_type !== 'Trial' && currentUser?.account_type !== 'Trial-plus' && (
            <li className='nav-item'>
              <Link
                to={'/tests'}
                className={`nav-link me-6 ${
                  activeTab === 'control' ? 'text-active-primary active' : ''
                }`}
                onClick={() => handleTabClick('control')}
              >
                Linked Controls
              </Link>
            </li>
          )}
          <li className='nav-item'>
            <Link
              to={'/tests'}
              className={`nav-link me-6 ${
                activeTab === 'notes' ? 'text-active-primary active' : ''
              }`}
              onClick={() => handleTabClick('notes')}
            >
              Notes
            </Link>
          </li>

          {/* Uncomment if you want to add the Tasks tab back
          <li className='nav-item'>
            <Link
              to={'/tests'}
              className={`nav-link me-6 ${
                activeTab === 'tasks' ? 'text-active-primary active' : ''
              }`}
              onClick={() => handleTabClick('tasks')}
            >
              Tasks
            </Link>
          </li> */}
        </ul>
      </div>
    </div>
  )
}

export default TestTabs
